var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6206 11.4116C14.7638 11.4116 17.3342 8.85679 17.3342 5.71356C17.3342 2.57033 14.7793 0 11.6206 0C8.47739 0 5.92255 2.55485 5.92255 5.71356C5.92255 8.87227 8.47739 11.4116 11.6206 11.4116Z",
    fill: "#959FA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.08 13.6258H7.91998C4.26578 13.6258 1.30835 16.5987 1.30835 20.2374V21.2903C1.30835 22.7768 2.53158 24 4.01803 24H19.9819C21.4684 24 22.6916 22.7768 22.6916 21.2903V20.2529C22.6916 16.5987 19.7187 13.6258 16.08 13.6258Z",
    fill: "#959FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.587efdc8c93553f893ca65f032117b23.svg";
export { ForwardRef as ReactComponent };